export const Logo = ({ size = 40, withText = true, textClassName = "" }) => (
  <div className="flex items-center gap-3" data-testid="app-logo">
    <img src="/nolo-logo.png" alt="Nolo View logo" style={{ height: size, width: "auto" }} className="drop-shadow" />
    {withText && (
      <span className={`font-display text-2xl font-extrabold tracking-wide uppercase leading-none ${textClassName}`}>
        Nolo <span className="text-[#4accff]">View</span>
      </span>
    )}
  </div>
);
